module.exports = __webpack_public_path__ + "img/icon-403.26fecdc3.svg";